module.exports = __webpack_public_path__ + "src/assets/games/31/120.jpg";